import {createContext, useContext, type ReactNode} from 'react';
import japanese from './locales/ja.json';
import previews from '../config/design-previews.json';
import {APP_BASE, Link} from './router';

export type PublicLocale = 'en' | 'ja';
const translations: Record<string, string> = japanese;
const locales = {
  en: {locale: 'en' as const, t: (text: string) => text},
  ja: {locale: 'ja' as const, t: (text: string) => {
    if (!Object.hasOwn(translations, text)) throw new Error(`Missing Japanese translation: ${text}`);
    return translations[text]!;
  }},
};
const PublicLocaleContext = createContext(locales.en as typeof locales[PublicLocale]);

export function publicLocaleAtPath(path: string): PublicLocale {
  const preview = Object.values(previews).find(item => item.path === path);
  if (!preview) return 'en';
  if (preview.locale !== 'en' && preview.locale !== 'ja') throw new Error(`Unsupported preview language: ${preview.locale}`);
  return preview.locale;
}

export function PublicLocaleProvider({locale, children}: {locale: PublicLocale; children: ReactNode}) {
  return <PublicLocaleContext.Provider value={locales[locale]}>{children}</PublicLocaleContext.Provider>;
}
export function usePublicLocale() {return useContext(PublicLocaleContext);}

export function DesignPreviewLanguages({design}: {design: string}) {
  const {locale, t} = usePublicLocale();
  return <nav className="d2-languages" aria-label={t('Language')}>
    {Object.values(previews).filter(preview => preview.design === design).map(preview => <Link key={preview.locale} href={`${APP_BASE}${preview === previews.home ? '/' : preview.path}`} lang={preview.locale}
      hrefLang={preview.locale} aria-current={locale === preview.locale ? 'page' : undefined}>{preview.language}</Link>)}
  </nav>;
}
